module.exports = __webpack_public_path__ + "static/img/move_product_02.febc1fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/move_product_02.png
// module id = QZ4g
// module chunks = 0